import { ICategory } from 'server/models/Category';

export const isCategory = (obj: unknown): obj is ICategory =>
  (obj as ICategory)?.name !== undefined;
